import React from "react";
import { Box } from "@mui/material";
import { Field } from "react-final-form";
import * as styles from "../AccountForm.styles";
import { InputField, PhoneField } from "@dishopsaas/design-system";
export const PersonalInfoFields = ({
  setPhone,
  setIsPhoneIncorrect,
  updatePhoneObj,
  isPhoneIncorrect,
}: any) => {
  const renderInput = ({ input, meta, label, disabled }: any) => (
    <InputField
      label={label}
      value={input.value}
      type={input.name}
      onChange={input.onChange}
      onBlur={input.onBlur}
      onFocus={input.onFocus}
      disabled={disabled}
      error={meta.touched && meta.error}
      helperText={meta.touched && meta.error}
    />
  );

  const renderPhoneInput = ({ input, label }: any) => (
    <PhoneField
      label={label}
      value={input.value}
      onChange={(value) => {
        setPhone(value);
        input.onChange(value);
      }}
      isPhoneIncorrect={setIsPhoneIncorrect}
      getPhoneObj={updatePhoneObj}
      error={isPhoneIncorrect}
    />
  );
  return (
    <>
      <Box sx={styles.rowBox}>
        <Field
          name="firstName"
          type="text"
          label="Prénom"
          render={renderInput}
        />
        <Field
          name="lastName"
          type="text"
          label="Nom de famille"
          render={renderInput}
        />
      </Box>

      <Box sx={styles.rowBox}>
        <Field
          name="email"
          label="Adresse e-mail"
          type="text"
          render={(props) => renderInput({ ...props, disabled: true })}
        />
        <Field
          name="numero"
          label="Numéro de téléphone"
          render={renderPhoneInput}
        />
      </Box>
    </>
  );
};
